<div class="border bg-white p-2 m-3">
  <router-outlet></router-outlet>
</div>
